import { Phone, Calendar, Mail, MessageCircle, CheckSquare, StickyNote, Settings } from 'lucide-react';

// Hard-coded starter values for Activity Type/Channel (story #216). Mirrors
// backend/models/activity.js exactly — keep both in sync by hand. Outcome
// is the exception — it's tenant-editable (see activity-outcomes API,
// Settings > CRM > Setup > Activity Outcomes), fetched live rather than
// listed here.
export const ACTIVITY_TYPES = ['call', 'meeting', 'email', 'message', 'task', 'note', 'system'];

// System is recorded by the app itself (e.g. a Prospect converted to
// Customer) — shown in the Activities list, but never offered to log by
// hand, and read-only once there.
export const SYSTEM_ACTIVITY_TYPE = 'system';
export const LOGGABLE_ACTIVITY_TYPES = ACTIVITY_TYPES.filter((t) => t !== SYSTEM_ACTIVITY_TYPE);

export const ACTIVITY_TYPE_LABELS = { call: 'Call', meeting: 'Meeting', email: 'Email', message: 'Message', task: 'Task', note: 'Note', system: 'System' };
export const ACTIVITY_TYPE_ICONS = { call: Phone, meeting: Calendar, email: Mail, message: MessageCircle, task: CheckSquare, note: StickyNote, system: Settings };

// Channel only applies to Call/Message — left blank (and hidden in the form)
// for Meeting/Email.
export const CHANNEL_ACTIVITY_TYPES = ['call', 'message'];
// Website is set only by the website's own forms (issue #287), so the log
// form offers it only on an Activity that already has it.
export const CHANNELS = ['phone', 'whatsapp', 'sms', 'signal', 'website'];
export const WEBSITE_CHANNEL = 'website';
export const PICKABLE_CHANNELS = CHANNELS.filter((c) => c !== WEBSITE_CHANNEL);
export const CHANNEL_LABELS = { phone: 'Phone', whatsapp: 'WhatsApp', sms: 'SMS', signal: 'Signal', website: 'Website' };

export const DIRECTIONS = ['inbound', 'outbound'];
export const DIRECTION_LABELS = { inbound: 'Inbound', outbound: 'Outbound' };
